import { faPalette } from "@fortawesome/pro-solid-svg-icons";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { InferenceStyleParameters } from "../../../types";
import { getPercentageFromWeight } from "../../inference-forms/utils/utils";
import { Icon, Link, Tooltip, Typography, useTheme } from "../../ui-v2";

const StyledImage = styled("img")({
  maxWidth: "14px",
  maxHeight: "14px",
});

interface FileStyle {
  id: string;
  name: string;
  path: string;
  featuredFiles?: { file: { id: string; url?: string } }[];
}

interface ForgeInfoStylesProps {
  styles: FileStyle[];
  stylesParams?: InferenceStyleParameters[]; // Used to look up style weight
}

export const ForgeInfoStyles = (props: ForgeInfoStylesProps) => {
  const theme = useTheme();
  const { styles, stylesParams } = props;
  return (
    <Box>
      {styles.map((style) => {
        const featuredFile = style.featuredFiles?.[0]?.file;
        const weight =
          stylesParams?.find((styleParams) => styleParams.id === style.id)
            ?.weight || 0;

        return (
          <Box
            key={`style-info-${style?.id}`}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <Link
              key={style.id}
              href={style.path}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyContent: "flex-end",
                  alignItems: "center",
                  maxWidth: "100%",
                }}
              >
                {featuredFile ? (
                  <StyledImage src={featuredFile.url} />
                ) : (
                  <Icon icon={faPalette} />
                )}
                <Tooltip title={style.name}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "baseline",
                      flexGrow: 1,
                      minWidth: 0,
                    }}
                  >
                    <Typography
                      noWrap
                      sx={{
                        width: "100%",
                        flexGrow: 1,
                        minWidth: 0,
                        textDecoration: "underline",
                        textDecorationStyle: "dotted",
                        color: theme.palette.secondary[2],
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",

                        "&:hover": {
                          color: theme.palette.secondary[2],
                        },
                      }}
                    >
                      {style.name}
                    </Typography>
                    <Typography
                      variant="small"
                      sx={{
                        ml: 1,
                        flexShrink: 0,
                      }}
                    >
                      ({getPercentageFromWeight(weight)}%)
                    </Typography>
                  </Box>
                </Tooltip>
              </Stack>
            </Link>
          </Box>
        );
      })}
    </Box>
  );
};
